import _asyncToGenerator from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useKeyPress, Button } from '@miro-site/core';
import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import SearchDropdown from './components/SearchDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled.div.withConfig({
  displayName: "Search__Wrapper",
  componentId: "sc-rfsrnl-0"
})(["position:relative;box-sizing:content-box;z-index:3;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.normalizeStyles({
    paddingTop: 7,
    height: 40,
    paddingBottom: 7,
    paddingLeft: 0,
    paddingRight: 0
  });
});
var Input = styled.input.withConfig({
  displayName: "Search__Input",
  componentId: "sc-rfsrnl-1"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme,
      isFocused = _ref2.isFocused;
  return theme.normalizeStyles({
    color: 'primaryIndigo',
    border: [isFocused ? 'none' : '1px solid var(--wcds-search-input-border-color)'],
    outline: 'none',
    width: [isFocused ? '100%' : 44, '100%', '100%', '100%'],
    background: isFocused ? 'none' : ['none', 'var(--wcds-search-input-background-color)', 'var(--wcds-search-input-background-color)', 'var(--wcds-search-input-background-color)'],
    fontSize: [isFocused ? 16 : 0, 16, 16, 16],
    paddingLeft: [isFocused ? 36 : 0, 46, 46, 46],
    paddingRight: [isFocused ? 36 : 0, 46, 46, 46],
    height: 40,
    borderRadius: 100
  });
});
export var SearchWrapper = styled.div.withConfig({
  displayName: "Search__SearchWrapper",
  componentId: "sc-rfsrnl-2"
})(["position:absolute;", ""], function (props) {
  if (props.isFocused) {
    return props.theme.normalizeStyles({
      border: '1px solid var(--wcds-search-input-border-color)',
      borderRadius: 16,
      left: 0,
      right: 0,
      top: 0,
      boxShadow: '0px 8px 44px rgba(var(--wcds-colors-indigo-90-rgb), 0.16)',
      background: 'var(--wcds-colors-white)'
    });
  } else {
    return props.theme.normalizeStyles({
      left: 0,
      right: 0,
      paddingLeft: 0,
      paddingRight: 0
    });
  }
});
var SvgSearchIcon = styled.svg.withConfig({
  displayName: "Search__SvgSearchIcon",
  componentId: "sc-rfsrnl-3"
})(["position:absolute;cursor:pointer;top:50%;", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.normalizeStyles({
    width: 24,
    height: 24,
    marginTop: -12
  });
});
var SvgCloseIconWrapper = styled(Button).withConfig({
  displayName: "Search__SvgCloseIconWrapper",
  componentId: "sc-rfsrnl-4"
})(["position:absolute;cursor:pointer;top:50%;line-height:1px;", ";&:focus{", "}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.normalizeStyles({
    width: 24,
    height: 24,
    marginTop: -12
  });
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.normalizeStyles(_objectSpread({}, theme.focus.outlines.withOffset));
});
var SearchInputWrapper = styled.div.withConfig({
  displayName: "Search__SearchInputWrapper",
  componentId: "sc-rfsrnl-5"
})(["position:relative;line-height:0;", ""], function (_ref6) {
  var theme = _ref6.theme,
      isFocused = _ref6.isFocused;
  return css(["", " ", "{", "}", "{", "}"], isFocused && theme.normalizeStyles({
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: [10, 34, 34, 34],
    paddingRight: [10, 34, 34, 34]
  }), SvgSearchIcon, theme.normalizeStyles({
    left: isFocused ? [10, 34, 34, 34] : 10,
    zIndex: isFocused ? 1 : [-1, 1, 1, 1]
  }), SvgCloseIconWrapper, theme.normalizeStyles({
    right: isFocused ? [10, 34, 34, 34] : 10
  }));
});

var Search = function Search(props) {
  var wrapperRef = useRef(null);
  var inputRef = useRef(null);
  var isEscapePressed = useKeyPress('Escape');

  var _useState = useState(false),
      isFocused = _useState[0],
      setFocused = _useState[1];

  var _useState2 = useState(''),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(0),
      selected = _useState3[0],
      setSelected = _useState3[1];

  var handleClick = function handleClick(e) {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setFocused(false);
    }
  };

  useEffect(function () {
    if (props.onFocusChanged) {
      props.onFocusChanged(isFocused);
    }

    if (isFocused) {
      document.addEventListener('click', handleClick, true);
      window.addEventListener('focusin', onFocusDown);
      return function () {
        document.removeEventListener('click', handleClick, true);
        document.removeEventListener('keydown', onFocusDown);
      };
    }
  }, [isFocused]);

  var onFocusDown = function onFocusDown() {
    if (wrapperRef.current && !wrapperRef.current.contains(document.activeElement)) {
      setFocused(false);
    }
  };

  useEffect(function () {
    function performSearch() {
      return _performSearch.apply(this, arguments);
    }

    function _performSearch() {
      _performSearch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return props.onSearch(value);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _performSearch.apply(this, arguments);
    }

    if (value) {
      performSearch();
    }
  }, [value]);
  useEffect(function () {
    if (isFocused && isEscapePressed) {
      setFocused(false);
    }
  }, [isEscapePressed]);
  useEffect(function () {
    if (!isFocused && inputRef.current) {
      inputRef.current.blur();
    }
  }, [isFocused]);
  useEffect(function () {
    var _props$searchResult;

    if (!((_props$searchResult = props.searchResult) !== null && _props$searchResult !== void 0 && _props$searchResult.length)) {
      return;
    }

    document.addEventListener('keydown', onKeyDown);
    return function () {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [props.searchResult, selected]);

  var onKeyDown = function onKeyDown(e) {
    if (e.code === 'ArrowUp' && isFocused) {
      // up
      select(selected - 1);
    }

    if (e.code === 'ArrowDown' && isFocused) {
      // down
      select(selected + 1);
    }
  };

  var select = function select(activeIndex) {
    var _props$searchResult2;

    if (typeof ((_props$searchResult2 = props.searchResult) === null || _props$searchResult2 === void 0 ? void 0 : _props$searchResult2[activeIndex]) === 'undefined') {
      return;
    }

    setSelected(activeIndex);
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.code === 'Enter') {
      setValue('');

      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  };

  return /*#__PURE__*/_jsx(Wrapper, {
    ref: wrapperRef,
    className: props.className,
    children: /*#__PURE__*/_jsxs(SearchWrapper, {
      isFocused: isFocused,
      children: [/*#__PURE__*/_jsxs(SearchInputWrapper, {
        isFocused: isFocused,
        children: [/*#__PURE__*/_jsxs(SvgSearchIcon, {
          viewBox: "0 0 24 24",
          fill: "none",
          onClick: function onClick() {
            setFocused(true);
          },
          children: [/*#__PURE__*/_jsx("circle", {
            cx: "10.2308",
            cy: "10.0879",
            r: "6.23077",
            stroke: "var(--wcds-colors-text-secondary)",
            strokeWidth: "2"
          }), /*#__PURE__*/_jsx("path", {
            d: "M15 15.0002L21 21.0002",
            stroke: "var(--wcds-colors-text-secondary)",
            strokeWidth: "2",
            strokeLinecap: "round"
          })]
        }), /*#__PURE__*/_jsx(Input, {
          ref: inputRef,
          isFocused: isFocused,
          onFocus: function onFocus() {
            setFocused(true);
          },
          value: value,
          onChange: function onChange(e) {
            setValue(e.target.value);
          },
          onBlur: function onBlur() {
            if (value.length === 0) setFocused(false);
          } //for autotest
          ,
          "data-testid": "templates-search-input"
        }), isFocused && value.length > 0 && /*#__PURE__*/_jsx(SvgCloseIconWrapper, {
          onKeyDown: handleKeyDown,
          children: /*#__PURE__*/_jsx("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            onClick: function onClick() {
              setValue('');

              if (inputRef.current) {
                inputRef.current.focus();
              }
            },
            children: /*#__PURE__*/_jsx("path", {
              d: "M10.5858 12L4.29289 18.2929C3.90237 18.6834 3.90237 19.3166 4.29289 19.7071C4.68342 20.0976 5.31658 20.0976 5.70711 19.7071L12 13.4142L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L13.4142 12L19.7071 5.70711C20.0976 5.31658 20.0976 4.68342 19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289L12 10.5858L5.70711 4.29289C5.31658 3.90237 4.68342 3.90237 4.29289 4.29289C3.90237 4.68342 3.90237 5.31658 4.29289 5.70711L10.5858 12Z",
              fill: "#050038"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(SearchDropdown, {
        onSelectTemplate: function onSelectTemplate(template) {
          setFocused(false);
          setValue('');

          if (props.onSelectTemplate) {
            props.onSelectTemplate(template);
          }
        },
        isSearching: props.isSearching,
        searchString: value,
        open: isFocused && value.length > 0,
        searchResult: props.searchResult,
        statusMessages: props.statusMessages,
        activeIndex: selected,
        onItemHover: function onItemHover(itemIndexHover) {
          setSelected(itemIndexHover);
        }
      })]
    })
  });
};

export default Search;